var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSortFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "black",
    fillOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0098 17.451C12.0098 16.5034 12.778 15.7353 13.7255 15.7353H24.5098C25.4574 15.7353 26.2255 16.5034 26.2255 17.451C26.2255 18.3985 25.4574 19.1667 24.5098 19.1667H13.7255C12.778 19.1667 12.0098 18.3985 12.0098 17.451Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0098 25C12.0098 24.0524 12.778 23.2843 13.7255 23.2843H22.0588C23.0064 23.2843 23.7745 24.0524 23.7745 25C23.7745 25.9475 23.0064 26.7157 22.0588 26.7157H13.7255C12.778 26.7157 12.0098 25.9475 12.0098 25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8431 32.1078L32.8431 17.8922C32.8431 17.08 33.5015 16.4216 34.3137 16.4216C35.1259 16.4216 35.7843 17.08 35.7843 17.8922L35.7843 32.1078C35.7843 32.92 35.1259 33.5784 34.3137 33.5784C33.5015 33.5784 32.8431 32.92 32.8431 32.1078Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0098 32.549C12.0098 31.6015 12.778 30.8333 13.7255 30.8333H20.0981C21.0456 30.8333 21.8137 31.6015 21.8137 32.549C21.8137 33.4965 21.0456 34.2647 20.0981 34.2647H13.7255C12.778 34.2647 12.0098 33.4965 12.0098 32.549Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6205 14.993L31.0703 17.5432C30.6874 17.9261 30.6874 18.5468 31.0703 18.9297C31.4531 19.3125 32.0739 19.3125 32.4568 18.9297L34.3137 17.0727L36.1707 18.9297C36.5536 19.3125 37.1743 19.3125 37.5572 18.9297C37.94 18.5468 37.94 17.9261 37.5572 17.5432L35.007 14.993C34.6241 14.6101 34.0033 14.6101 33.6205 14.993Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.007 34.9089L37.6812 32.2347C38.0641 31.8518 38.0641 31.2311 37.6812 30.8482C37.2983 30.4653 36.6776 30.4653 36.2947 30.8482L34.3137 32.8292L32.3327 30.8482C31.9498 30.4653 31.3291 30.4653 30.9462 30.8482C30.5634 31.2311 30.5634 31.8518 30.9462 32.2347L33.6205 34.9089C34.0033 35.2918 34.6241 35.2918 35.007 34.9089Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortFilled);
export default __webpack_public_path__ + "static/media/ic_sort_filled.815156dcbbf050440e837b3bcad7fb17.svg";
export { ForwardRef as ReactComponent };